import isBuilderContext from "@/lib/is-platform/is-builder-context"

// https://github.com/you-dont-need/You-Dont-Need-Lodash-Underscore#_isempty
export const isEmpty = obj =>
  [Object, Array].includes((obj || {}).constructor) &&
  !Object.entries(obj || {}).length

export const isPresent = obj => !isEmpty(obj)
export const isBoolean = bool => typeof bool === "boolean"

//https://stackoverflow.com/a/33121880
export const unique = array => [...new Set(array)]

export const getImageUrl = (image, defaultUrl = null) =>
  !isEmpty(image) && !isEmpty(image.image) ? image.image.url : defaultUrl

export const capitalizeFirstLetter = str =>
  str.charAt(0).toUpperCase() + str.slice(1)

// https://youmightnotneed.com/lodash/#omit
export const omit = (object, keysToRemove) => {
  const obj = { ...object }
  keysToRemove.forEach(key => delete obj[key])
  return obj
}

export const isObject = obj => typeof obj === "object" && obj !== null

export const clientWidth = () =>
  window.innerWidth ||
  document.documentElement.clientWidth ||
  document.body.clientWidth

export const clientHeight = () =>
  window.innerHeight ||
  document.documentElement.clientHeight ||
  document.body.clientHeight

export const getHostName = url => {
  const parser = document.createElement("a")
  parser.href = url

  if (parser.hostname === "localhost") {
    return url
  } else {
    return parser.hostname
  }
}

export const isString = str => typeof str === "string"

export const pluralize = (string, amount = 2) =>
  amount > 1 && !string.endsWith("s") ? `${string}s` : string

export const getInitials = string => {
  if (!isString(string)) return ""

  const SIMPLE_EMAIL_REGEX = /^\S+@\S+\.\S+$/

  if (string.match(SIMPLE_EMAIL_REGEX)) {
    return string.slice(0, 2).toUpperCase()
  } else {
    return string
      .replace(/[^a-zA-Z- ]/g, " ")
      .replace(/  +/g, " ")
      .split(" ")
      .slice(0, 2)
      .map(s => s.charAt(0))
      .join("")
      .toUpperCase()
  }
}

export const hasKey = (obj, key) =>
  Object.prototype.hasOwnProperty.call(obj, key)

export const isWebLink = link =>
  link &&
  (link.startsWith("http") ||
    link.startsWith("mailto") ||
    link.startsWith("tel"))

export const replaceQueryParam = (router, param) =>
  router.replace({ query: { ...router.currentRoute.query, ...param } })

export const eventPath = event =>
  event.path || (event.composedPath && event.composedPath())

export const findAsync = async (arr, asyncCallback) => {
  const promises = arr.map(asyncCallback)
  const results = await Promise.all(promises)
  const index = results.findIndex(result => result)
  return arr[index]
}

export const formatSlug = slug =>
  slug
    .split("-")
    .map(capitalizeFirstLetter)
    .join(" ")

export const getParentElementsBySelector = (
  node,
  selector,
  includeSelf = false,
  acc = []
) => {
  if (includeSelf && node.matches(selector)) {
    acc.push(node)
  }

  if (node.parentElement) {
    return getParentElementsBySelector(node.parentElement, selector, true, acc)
  }

  return acc
}

export { isBuilderContext }
